<template>
  <div class="my-6 leading-normal">
    <h1 class="text-xl mb-2">Create New Referral</h1>

    <div class="flex flex-wrap -mx-2">
      <div class="flex-col w-full md:w-1/2 px-2">
        <panel class="pt-6 mb-6">
          <h2 class="font-bold text-sm mb-3">Referral</h2>
          <div class="mb-6" v-if="leadSource.can_customise_referrer">
            <label>Referring Agent:</label>
            <select
              v-model="form.referred_by_office_id"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('referred_by_office_id') }">
              <option v-for="office in offices" :key="office.id" :value="office.id">{{ office.name }} ({{ office.address_town }})</option>
            </select>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('referred_by_office_id')" v-text="errorBag.get('referred_by_office_id')"></small>
          </div>

          <div class="mb-6" v-if="leadSource.can_customise_referrer">
            <label>Lead Source URL:</label>
            <input v-model="form.lead_source_url"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('lead_source_url') }" />
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('lead_source_url')" v-text="errorBag.get('lead_source_url')"></small>
          </div>

          <div class="mb-6">
            <label>Referral Type:</label>
            <select
              v-model="form.type_id"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('type_id') }">
              <option :value="null">[Please Select]</option>
              <option :value="1">I have someone looking to sell a property</option>
              <option :value="2">I have someone looking to buy a property</option>
            </select>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('type_id')" v-text="errorBag.get('type_id')"></small>
          </div>

          <div class="mb-6" v-if="form.type_id">
            <label>Reason for Move:</label>
            <select
              v-model="form.move_reason_id"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('move_reason_id') }">
              <option :value="null">[Please Select]</option>
              <option :value="1">Relocating for work</option>
              <option :value="2">Relocating for family</option>
              <option :value="3">Personal reasons</option>
              <option :value="4">Downsizing</option>
              <option :value="5">Upsizing</option>
              <option :value="8">Permanent Home</option>
              <option :value="9">Second Home</option>
              <option :value="10">Investment Purpose</option>
              <option :value="6">Other</option>
            </select>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('move_reason_id')" v-text="errorBag.get('move_reason_id')"></small>
          </div>

          <div class="mb-6" v-if="form.move_reason_id === 6">
            <label>Other Move Reason:</label>
            <textarea
              v-model="form.move_reason_other"
              rows="4"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('move_reason_other') }">
            </textarea>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('move_reason_other')" v-text="errorBag.get('move_reason_other')"></small>
          </div>

          <div class="mb-6" v-if="form.type_id === 2">
            <label>Financial position:</label>
            <div class="flex flex-wrap my-2">
              <input type="radio" id="fanancial_position_buyer" v-model="form.financial_position_type_id" :value="1" />
              <label for="fanancial_position_buyer" class="mr-4">
                Cash Buyer
              </label>
              <input type="radio" id="fanancial_position_required" v-model="form.financial_position_type_id" :value="2" />
              <label for="fanancial_position_required" class="mr-4">
                Finance Required
              </label>
              <input type="radio" id="fanancial_position_other" v-model="form.financial_position_type_id" :value="3" />
              <label for="fanancial_position_other" class="mr-4">
                Unknown
              </label>
            </div>
          </div>
          <div class="mb-6" v-if="form.type_id">
            <input type="checkbox" id="currently_listed" v-model="form.currently_listed">
            <label for="currently_listed">Currently on the market</label>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('currently_listed')" v-text="errorBag.get('currently_listed')"></small>
          </div>
        </panel>

        <panel class="pt-6 mb-6" v-if="form.type_id">
          <h2 class="font-bold text-sm mb-3">Property to {{ form.type_id === 1 ? 'Sell' : 'Buy' }}</h2>

          <div class="mb-6 flex flex-wrap -mx-2">
            <div class="w-full md:w-1/2 px-2" v-if="[7, 8].includes(selectedOffice.network_id)">
              <label>Country:</label>
              <select v-model="form.address_country" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
                <option value="AU">Australia</option>
                <option value="BB">Barbados</option>
                <option value="CY">Cyprus</option>
                <option value="FR">France</option>
                <option value="DE">Germany</option>
                <option value="HU">Hungary</option>
                <option value="IE">Ireland</option>
                <option value="JE">Jersey</option>
                <option value="MU">Mauritius</option>
                <option value="NA">Namibia</option>
                <option value="PT">Portugal</option>
                <option value="ZA">South Africa</option>
                <option value="ES">Spain</option>
                <option value="CH">Switzerland</option>
                <option value="TH">Thailand</option>
                <option value="AE">United Arab Emirates</option>
                <option value="GB">United Kingdom</option>
                <option value="ZW">Zimbabwe</option>
              </select>
              <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('address_country')" v-text="errorBag.get('address_country')"></small>
            </div>
            <div class="w-full px-2" :class="{'md:w-1/2': [7, 8].includes(selectedOffice.network_id)}">
              <label>Property Type:</label>
              <select
                v-model="form.property_type_id"
                class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('property_type_id') }">
                <optgroup label="(Not Specified)">
                  <option :value="0">Not Specified</option>
                </optgroup>
                <optgroup label="House">
                  <option :value="24">Chalet</option>
                  <option :value="6">Cluster House</option>
                  <option :value="23">Cottage</option>
                  <option :value="1014">Cottage</option>
                  <option :value="4">Detached House</option>
                  <option :value="131">Detached Villa</option>
                  <option :value="2">End of Terrace House</option>
                  <option :value="30">Finca</option>
                  <option :value="26">House</option>
                  <option :value="1025">House - With Land</option>
                  <option :value="1024">
                    House with additional accommodation
                  </option>
                  <option :value="21">Link Detached House</option>
                  <option :value="5">Mews House</option>
                  <option :value="3">Semi-Detached House</option>
                  <option :value="128">Semi-Detached Villa</option>
                  <option :value="1">Terraced House</option>
                  <option :value="22">Town House</option>
                  <option :value="27">Villa</option>
                  <option :value="95">Village House</option>
                </optgroup>
                <optgroup label="Flat / Apartment">
                  <option :value="28">Apartment</option>
                  <option :value="143">Block of Apartments</option>
                  <option :value="511">Coach House</option>
                  <option :value="56">Duplex</option>
                  <option :value="8">Flat</option>
                  <option :value="7">Ground Flat</option>
                  <option :value="1034">Ground Floor Apartment</option>
                  <option :value="10">Ground Maisonette</option>
                  <option :value="142">Hotel Room</option>
                  <option :value="1038">Luxury Apartment</option>
                  <option :value="11">Maisonette</option>
                  <option :value="29">Penthouse</option>
                  <option :value="144">Private Halls</option>
                  <option :value="44">Serviced Apartment</option>
                  <option :value="9">Studio</option>
                  <option :value="59">Triplex</option>
                </optgroup>
                <optgroup label="Bungalow">
                  <option :value="12">Bungalow</option>
                  <option :value="15">Detached Bungalow</option>
                  <option :value="14">Semi-Detached Bungalow</option>
                  <option :value="13">Terraced Bungalow</option>
                </optgroup>
                <optgroup label="Character Property">
                  <option :value="68">Barn</option>
                  <option :value="43">Barn Conversion</option>
                  <option :value="92">Castle</option>
                  <option :value="101">Cave House</option>
                  <option :value="25">Character Property</option>
                  <option :value="104">Cortijo</option>
                  <option :value="113">Country House</option>
                  <option :value="53">Equestrian</option>
                  <option :value="52">Farm House</option>
                  <option :value="65">Gite</option>
                  <option :value="141">House Boat</option>
                  <option :value="118">Lodge</option>
                  <option :value="119">Log Cabin</option>
                  <option :value="62">Longere</option>
                  <option :value="120">Manor House</option>
                  <option :value="74">Mill</option>
                  <option :value="140">Riad</option>
                  <option :value="77">Ruins</option>
                  <option :value="121">Stately Home</option>
                  <option :value="116">Stone House</option>
                  <option :value="71">Trulli</option>
                </optgroup>
                <optgroup label="Commercial Property">
                  <option :value="134">Bar</option>
                  <option :value="284">Beach / Ocean Front</option>
                  <option :value="181">Business Park</option>
                  <option :value="83">Café</option>
                  <option :value="244">Commercial Development</option>
                  <option :value="19">Commercial Property</option>
                  <option :value="253">Commercial Property</option>
                  <option :value="193">Convenience Store</option>
                  <option :value="256">Data Centre</option>
                  <option :value="1009">Development</option>
                  <option :value="217">Distribution Warehouse</option>
                  <option :value="286">Equestrian</option>
                  <option :value="220">Factory</option>
                  <option :value="259">Farm</option>
                  <option :value="1022">Farm - Livestock</option>
                  <option :value="288">Farms &amp; Ranches</option>
                  <option :value="9998">Game Farms</option>
                  <option :value="9999">Game Lodges</option>
                  <option :value="196">Garage</option>
                  <option :value="287">Golf</option>
                  <option :value="1016">Guest Farm</option>
                  <option :value="277">Guest House</option>
                  <option :value="199">Hairdresser / Barber Shop</option>
                  <option :value="262">Healthcare Facility</option>
                  <option :value="223">Heavy Industrial</option>
                  <option :value="1021">Historic Farm</option>
                  <option :value="280">Hospitality</option>
                  <option :value="202">Hotel</option>
                  <option :value="247">Industrial Development</option>
                  <option :value="226">Industrial Park</option>
                  <option :value="1002">Industrial/Warehouse</option>
                  <option :value="241">Land</option>
                  <option :value="283">Leisure Facility</option>
                  <option :value="229">Light Industrial</option>
                  <option :value="265">Marine Property</option>
                  <option :value="86">Mill</option>
                  <option :value="268">Mixed Use</option>
                  <option :value="178">Office</option>
                  <option :value="1003">Office Sharing</option>
                  <option :value="1000">Offices</option>
                  <option :value="205">Petrol Station</option>
                  <option :value="208">Post Office</option>
                  <option :value="211">Pub</option>
                  <option :value="271">
                    Research &amp; Development Facility
                  </option>
                  <option :value="250">Residential Development</option>
                  <option :value="80">Restaurant</option>
                  <option :value="187">
                    Retail Property (High Street)
                  </option>
                  <option :value="190">
                    Retail Property (Out of Town)
                  </option>
                  <option :value="274">Science Park</option>
                  <option :value="1005">Sectional Title</option>
                  <option :value="1006">Secure Estate</option>
                  <option :value="1007">Secure Golfing Estate</option>
                  <option :value="1008">Secure Wild Life Estate</option>
                  <option :value="184">Serviced Office</option>
                  <option :value="1004">Serviced Offices</option>
                  <option :value="137">Shop</option>
                  <option :value="1001">Shops</option>
                  <option :value="235">Showroom</option>
                  <option :value="1032">Smallholding - 2-50 Acres</option>
                  <option :value="232">Storage</option>
                  <option :value="89">Trulli</option>
                  <option :value="1010">Vacant Land</option>
                  <option :value="289">Vacation Rentals</option>
                  <option :value="238">Warehouse</option>
                  <option :value="285">Water Front</option>
                  <option :value="1018">Winery</option>
                  <option :value="214">Workshop &amp; Retail Space</option>
                </optgroup>
                <optgroup label="Garage / Parking">
                  <option :value="51">Garage</option>
                  <option :value="45">Parking</option>
                </optgroup>
                <optgroup label="Guest House / Hotel">
                  <option :value="18">Guest House</option>
                  <option :value="17">Hotel</option>
                </optgroup>
                <optgroup label="House / Flat Share">
                  <option :value="49">Flat Share</option>
                  <option :value="48">House Share</option>
                </optgroup>
                <optgroup label="Land">
                  <option :value="107">Farm Land</option>
                  <option :value="20">Land</option>
                  <option :value="125">Off-Plan</option>
                  <option :value="110">Plot</option>
                </optgroup>
                <optgroup label="Mobile / Park Home">
                  <option :value="117">Caravan</option>
                  <option :value="16">Mobile Home</option>
                  <option :value="50">Park Home</option>
                </optgroup>
                <optgroup label="Retirement Property">
                  <option :value="47">Retirement Property</option>
                  <option :value="46">Sheltered Housing</option>
                </optgroup>
              </select>
              <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('property_type_id')" v-text="errorBag.get('property_type_id')"></small>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2">
            <div class="w-full md:w-1/2 px-2">
              <div class="mb-6">
                <label>Bedrooms:</label>
                <input
                  type="number"
                  min="0"
                  v-model="form.bedrooms"
                  class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('bedrooms') }" />
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('bedrooms')" v-text="errorBag.get('bedrooms')"></small>
              </div>
            </div>

            <div class="w-full md:w-1/2 px-2">
              <div class="mb-6">
                <label>{{ form.type_id === 1 ? 'Approximate Value' : 'Budget' }} ({{ this.currencySymbol }}):</label>
                <input
                  type="text"
                  pattern="\d*"
                  @keydown="numbersOnly"
                  v-model="form.budget"
                  class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('budget') }" />
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('budget')" v-text="errorBag.get('budget')"></small>
              </div>
            </div>
          </div>

          <div class="mb-6" v-if="form.type_id === 1">
            <label>Address:</label>
            <input
                v-model="address"
                class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
                readonly
                @click="addressLookupOpen = true" />
            <address-lookup-modal
              v-if="addressLookupOpen"
              v-model="form"
              @leave="addressLookupOpen = false"
              :country-key="[7, 8].includes(selectedOffice.network_id) ? 'address_country' : null"
                />
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('address_name_number')" v-text="errorBag.get('address_name_number')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('address_line2')" v-text="errorBag.get('address_line2')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('address_line3')" v-text="errorBag.get('address_line3')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('address_town')" v-text="errorBag.get('address_town')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('address_line4')" v-text="errorBag.get('address_line4')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('address_postcode')" v-text="errorBag.get('address_postcode')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('address_country')" v-text="errorBag.get('address_country')"></small>
          </div>

          <div class="mb-6" v-if="form.type_id === 2">
            <hr class="border-b mt-4 mb-8" />

            <h2 class="font-bold text-sm mb-3">Area of interest</h2>
            <p class="text-sm" v-if="selectedOffice.network_id !== 2 && form.address_country !== 'GB'">Please enter the desired location in the search bar and tick the offices where your applicant is interested in buying in.</p>
            <div class="text-sm mt-4 mb-2">Location:</div>

            <div class="mb-2">
              <input
                v-model="form.desired_area"
                class="block w-full border p-2 mt-2 h-10 text-sm" v-if="form.address_country === 'GB'" />
              <!-- <autocomplete
                ref="address_autocomplete"
                v-model="form.desired_area"
                placeholder="Type your desired location here"
                :source="addressEndpoint"
                :request-headers="authHeaders"
                results-property="name"
                results-value="name"
                results-display="name"
                input-class="px-2"
                @selected="addressSelected"
                v-if="form.address_country === 'GB'"
              >
              </autocomplete> -->
              <div v-else class="flex flex-shrink items-center">
                <input
                  v-model="form.desired_area"
                  class="block w-full border p-2 mt-2 h-10 text-sm" />
                <i class="fas fa-search fa-2x p-2 mt-2 cursor-pointer" @click="getNearbyAgents(form.desired_area,50)"></i>
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('desired_area')" v-text="errorBag.get('desired_area')"></small>
              </div>
            </div>

            <div class="mb-4">
              <div v-if="!agentResults.data"><!-- show nothing --></div>
              <div v-else-if="agentResults.data.length === 0">
                <div class="text-red">
                  <i class="fas fa-info-circle"></i> Your search returned no results.
                </div>
                <div class="flex flex-wrap my-2">
                  <input type="checkbox" id="head_office" name="selected_offices" :value="0" :checked="form.referred_to_office_id.includes(0)" @click="updateSelectedAgent(0)" />
                  <label for="head_office" class="mr-4">
                    Head Office
                  </label>
                </div>
              </div>
              <div v-else class="flex flex-wrap">
                <div class="text-red" v-if="showMaxErrMsg">
                  <i class="fas fa-info-circle"></i> The maximum number of offices that can be assigned a buying referral is five.
                </div>
                <div class="w-1/2 flex flex-wrap my-2"  v-for="office in agentResults.data" :key="office.id">
                  <input type="checkbox" :id="office.id" name="selected_offices" :value="office.id" :checked="form.referred_to_office_id.includes(office.id)" @click="updateSelectedAgent(office.id)" />
                  <label :for="office.id" class="mr-4 tooltip-container">
                    <span style="white-space: normal;line-height: 1.5">
                      {{ office.name }}
                    </span>
                    <div class="absolute border border-bg-primary p-2 bg-white z-10 rounded normal-case mt-1 tooltip-msg">
                      <div class="flex-grow p-3">
                        <div class="mb-2"><i class="fas"></i>{{ office.name }} ({{ office.address_town }})</div>
                        <div class="mb-2"><i class="fas fa-phone mr-2"></i> {{ office.sales_phone }}</div>
                        <div class="mb-2"><i class="fas fa-envelope mr-2"></i>
                          <a :href="`mailto:${office.sales_email}`" class="no-underline hover:underline text-primary">{{ office.sales_email }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
                <div class="items-stretch w-full" v-if="agentResults">
                  <div class="w-full">
                    <GmapMap
                      class="w-full h-120 mb-6 sm:mb-0 rounded overflow-hidden"
                      ref="agentsMap"
                      :center="{lat: agentResults.coordinates.lat, lng: agentResults.coordinates.lon}"
                      :zoom="map.zoom"
                      :options="map.options">
                      <GmapCircle
                        v-if="agentResults.data !== null"
                        :center="{lat: agentResults.coordinates.lat, lng: agentResults.coordinates.lon}"
                        :radius="24140.2"
                        :options="{fillColor: 'white', strokeColor: 'navy'}" />

                      <GmapMarker
                        v-if="agentResults.data !== null"
                        :position="{lat: agentResults.coordinates.lat, lng: agentResults.coordinates.lon}"
                        :icon="{url: 'http://maps.google.com/mapfiles/kml/paddle/blu-circle.png', scaledSize: {width: 32, height: 32}}"
                        :title="agentResults.coordinates.address"
                      >
                      </GmapMarker>

                      <GmapMarker
                        v-for="office in agentResults.data"
                        :key="office.id"
                        :position="{lat: office.coordinates.lat, lng: office.coordinates.lon}"
                        :icon="{url: form.referred_to_office_id.includes(office.id) ? 'http://maps.google.com/mapfiles/kml/paddle/grn-circle.png' : 'http://maps.google.com/mapfiles/kml/paddle/wht-circle.png', scaledSize: {width: 32, height: 32}}"
                        @click="updateSelectedAgent(office.id)"
                        @mouseover="map.showByIndex = office.id;"
                        @mouseout="map.showByIndex = null"
                      >
                        <gmap-info-window
                          :opened="map.showByIndex === office.id"
                        >
                          <div class="flex-grow p-3">
                            <div class="mb-2">{{ office.name }} ({{ office.address_town }})</div>
                            <div class="mb-2"><i class="fas fa-phone mr-2"></i> {{ office.sales_phone }}</div>
                            <div class="mb-2"><i class="fas fa-envelope mr-2"></i>{{ office.sales_email }}</div>
                          </div>
                        </gmap-info-window>
                      </GmapMarker>
                    </GmapMap>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <panel class="pt-6 my-6 w-full" v-if="internationalBuyerCustomiseFee">
            <h2 class="font-bold text-sm mb-2">Custom Commission</h2>
            <div class="flex">
              <span class="mr-4"><i class="fa fa-exclamation-triangle text-red"></i></span>
              <div>
                <p>
                  <span v-if="form.type_id === 1">{{form.address_country|countryName}} is a Buyer lead market. Therefore sale referrals are not so important.</span>
                  <span v-else>Buying referrals are very important to the {{form.address_country|countryName}} offices. </span>
                  We suggested a commission split of
                  <span>{{ leadSource.fees[0][form.type_id === 1 ? 'vendor_referral_fee' : 'applicant_referral_fee'] }}%</span>
                  for {{ form.type_id === 1 ? 'selling' : 'buying' }} referrals within {{form.address_country|countryName}} in the box below. You can however change the commission amount to what you feel is acceptable.
                </p>
                <div class="flex flex-wrap my-6">
                  <span class="w-full">Referral Fee = {{ leadSource.fees[0][form.type_id === 1 ? 'vendor_referral_fee' : 'applicant_referral_fee'] }}% of the commission:</span>
                  <div class="w-full flex mt-2 items-center">
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      max="99.99"
                      v-model.number="form.unconfirmed_referral_fee"
                      :placeholder="leadSource.fees[0][form.type_id === 1 ? 'vendor_referral_fee' : 'applicant_referral_fee']"
                      @keydown="numbersOnly"
                      class="block bg-white border hover:border-grey focus:border-grey-dark p-2 h-10 text-sm w-20" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('unconfirmed_referral_fee') }" />
                    <span class="whitespace-no-wrap ml-2">%</span>
                  </div>
                </div>
              </div>
            </div>
          </panel>

        </panel>
      </div>

      <div class="flex-col w-full md:w-1/2 px-2" v-if="form.type_id">
        <panel class="pt-6 mb-6">
          <h2 class="font-bold text-sm mb-3">{{ applicantType }}</h2>

          <div class="flex flex-wrap -mx-2">
            <div class="w-full md:w-1/5 px-2">
              <div class="mb-6">
                <label>Title:</label>
                <select
                  v-model="form.vendor_title"
                  class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor_title') }">
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                  <option value="Ms">Ms</option>
                  <option value="Dr">Dr</option>
                  <option value="Sir">Sir</option>
                  <option value="Madam">Madam</option>
                </select>
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_title')" v-text="errorBag.get('vendor_title')"></small>
              </div>
            </div>

            <div class="w-full md:w-2/5 px-2">
              <div class="mb-6">
                <label>First Name:</label>
                <input
                  type="text"
                  v-model="form.vendor_first_name"
                  class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor_first_name') }" />
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_first_name')" v-text="errorBag.get('vendor_first_name')"></small>
              </div>
            </div>

            <div class="w-full md:w-2/5 px-2">
              <div class="mb-6">
                <label>Surname:</label>
                <input
                  type="text"
                  v-model="form.vendor_surname"
                  class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor_surname') }" />
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_surname')" v-text="errorBag.get('vendor_surname')"></small>
              </div>
            </div>
          </div>

          <div class="mb-6">
            <label>Phone Number:</label>
            <input
              type="text"
              v-model="form.vendor_phone"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor_phone') }" />
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_phone')" v-text="errorBag.get('vendor_phone')"></small>
          </div>

          <div class="mb-6">
            <label>Email Address:</label>
            <input
              type="email"
              v-model="form.vendor_email"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor_email') }" />
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_email')" v-text="errorBag.get('vendor_email')"></small>
          </div>

          <div class="mb-6">
            <label>Home Address:</label>
            <div v-if="form.type_id === 1" class="py-2 text-sm">
              <input type="checkbox" id="match-address" v-model="sameAddress">
              <label for="match-address">Same as property address</label>
            </div>
            <input
                v-if="!sameAddress"
                v-model="vendorAddress"
                class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm"
                readonly
                @click="vendorAddressLookupOpen = true" />
            <address-lookup-modal
              v-if="vendorAddressLookupOpen"
              v-model="form"
              @leave="vendorAddressLookupOpen = false"
              name-number-key="vendor_address_name_number"
              street-key="vendor_address_line2"
              line3-key="vendor_address_line3"
              town-key="vendor_address_town"
              county-key="vendor_address_line4"
              postcode-key="vendor_address_postcode"
              :country-key="[7, 8].includes(selectedOffice.network_id) ? 'vendor_address_country' : null"
                />
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_address_name_number')" v-text="errorBag.get('vendor_address_name_number')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_address_line2')" v-text="errorBag.get('vendor_address_line2')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_address_line3')" v-text="errorBag.get('vendor_address_line3')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_address_town')" v-text="errorBag.get('vendor_address_town')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_address_line4')" v-text="errorBag.get('vendor_address_line4')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_address_postcode')" v-text="errorBag.get('vendor_address_postcode')"></small>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor_address_country')" v-text="errorBag.get('vendor_address_country')"></small>
          </div>

          <div v-if="secondVendor || form.vendor2_first_name">
            <hr class="border-b mt-4 mb-8" />
            <h2 class="font-bold text-sm mb-3">{{ applicantType }} Two</h2>
            <div class="flex flex-wrap -mx-2">
              <div class="w-full md:w-1/5 px-2">
                <div class="mb-6">
                  <label>Title:</label>
                  <select
                    v-model="form.vendor2_title"
                    class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor2_title') }">
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Miss">Miss</option>
                    <option value="Ms">Ms</option>
                    <option value="Dr">Dr</option>
                    <option value="Sir">Sir</option>
                    <option value="Madam">Madam</option>
                  </select>
                  <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor2_title')" v-text="errorBag.get('vendor2_title')"></small>
                </div>
              </div>

              <div class="w-full md:w-2/5 px-2">
                <div class="mb-6">
                  <label>First Name:</label>
                  <input
                    type="text"
                    v-model="form.vendor2_first_name"
                    class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor2_first_name') }" />
                  <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor2_first_name')" v-text="errorBag.get('vendor2_first_name')"></small>
                </div>
              </div>

              <div class="w-full md:w-2/5 px-2">
                <div class="mb-6">
                  <label>Surname:</label>
                  <input
                    type="text"
                    v-model="form.vendor2_surname"
                    class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor2_surname') }" />
                  <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor2_surname')" v-text="errorBag.get('vendor2_surname')"></small>
                </div>
              </div>
            </div>

            <div class="mb-6">
              <label>Phone Number:</label>
              <input
                type="text"
                v-model="form.vendor2_phone"
                class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor2_phone') }" />
              <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor2_phone')" v-text="errorBag.get('vendor2_phone')"></small>
            </div>

            <div class="mb-6">
              <label>Email Address:</label>
              <input
                type="email"
                v-model="form.vendor2_email"
                class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('vendor2_email') }" />
              <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('vendor2_email')" v-text="errorBag.get('vendor2_email')"></small>
            </div>
          </div>
          <div v-else @click="secondVendor = true" class="text-blue hover:text-blue-dark underline text-center cursor-pointer">Add second {{ applicantType.toLowerCase() }}</div>
        </panel>

        <panel class="pt-6 mb-6" v-if="canCustomiseFee && this.nearestOffice">
          <h2 class="font-bold text-sm mb-3">Referral Fee</h2>
          <p>
            {{ selectedOffice.name }} is set to receive
            <span v-if="form.referral_fee_override === leadSource.fees[0][form.type_id === 1 ? 'vendor_referral_fee' : 'applicant_referral_fee']">
              the standard {{ leadSource.fees[0][form.type_id === 1 ? 'vendor_referral_fee' : 'applicant_referral_fee'] }}%
            </span>
            <span v-else>
              a custom {{ form.referral_fee_override }}%
            </span>
            fee of the agreed sale price from {{ nearestOffice.name }} when this referral completes.
          </p>

          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('referral_fee_override')" v-text="errorBag.get('referral_fee_override')"></small>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('custom_fee_doc')" v-text="errorBag.get('custom_fee_doc')"></small>

          <div class="flex justify-end mt-6">
            <button class="text-black py-2 px-6 text-sm bg-white hover:bg-grey-lighter border border-primary rounded shadow" @click="showCustomFeeModal = true">
              <i class="fas fa-pencil-alt"></i> Customise Fee
            </button>
          </div>
        </panel>

        <panel class="pt-6 mb-6">
          <h2 class="font-bold text-sm mb-3">Notes</h2>

          <div class="mb-6">
            <textarea
              v-model="form.notes"
              rows="8"
              class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('notes') }">
            </textarea>
            <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('notes')" v-text="errorBag.get('notes')"></small>
          </div>
        </panel>
      </div>
    </div>

    <div class="flex justify-center" v-if="form.type_id">
      <button class="bg-transparent text-white py-2 px-6 bg-green-dark rounded shadow" :class="{'hover:bg-green': !saving}" @click="sendModalOpen = true" :disabled="saving">
        <loader v-if="saving || loading" fill-color="white" />
        <span v-else><i class="fas fa-paper-plane"></i> Send Referral</span>
      </button>
    </div>

    <modal v-if="sendModalOpen" @leave="sendModalOpen = false" show-close-btn width="320px">
      <h2 class="font-bold text-sm mb-1">Send Referral</h2>

      <div class="border p-3 h-48 overflow-y-auto leading-normal page-content my-6 text-sm" v-if="terms.sending" v-html="terms.sending"></div>
      <div class="border p-3 h-48 overflow-y-auto leading-normal page-content my-6 text-sm" v-else>No terms found in this region, please check below box directly</div>

      <div class="w-full lg:w-1/2 px-2 mb-2 text-sm">
        <input type="checkbox" id="terms" v-model="form.terms">
        <label for="terms">I accept the terms and conditions</label>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('terms')" v-text="errorBag.get('terms')"></small>
      </div>

      <div class="flex justify-end mt-6">
        <button class="bg-transparent text-white py-2 px-6 text-sm bg-green-dark rounded shadow" :class="{'hover:bg-green': !saving}" @click="save" :disabled="saving">
          <loader v-if="saving" fill-color="white" />
          <span v-else><i class="fas fa-paper-plane"></i> Send Referral</span>
        </button>
      </div>
    </modal>

    <modal v-if="showCustomFeeModal" @leave="showCustomFeeModal = false" show-close-btn width="320px">
      <h2 class="font-bold text-sm mb-1">Customise Referral Fee</h2>

      <p>
        If you have an agreement with {{ nearestOffice.name }} to customise the standard {{ leadSource.fees[0][form.type_id === 1 ? 'vendor_referral_fee' : 'applicant_referral_fee'] }}% fee of the agreed sale price you will receive for this referral, please enter the new agreement below and upload a PDF document displaying proof of the agreement.
      </p>

      <div class="flex items-center justify-center my-6 bg-grey-lighter rounded p-3">
        <span>{{ selectedOffice.name }} will receive</span>
        <input
          type="number"
          step="0.01"
          min="0"
          max="99.99"
          v-model.number="form.referral_fee_override"
          @keydown="numbersOnly"
          class="block bg-white border hover:border-grey focus:border-grey-dark p-2 h-10 text-sm mx-3 w-20" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('referral_fee_override') }" />
        <span class="whitespace-no-wrap">% of the agreed sale price</span>
      </div>

      <p class="mb-2">Please upload proof of this agreement:</p>
      <p v-if="form.custom_fee_doc"><span class="text-green-dark"><i class="fas fa-check-circle"></i> Document selected</span> (<span class="hover:underline cursor-pointer" @click="form.custom_fee_doc = null">Remove</span>)</p>
      <input v-else type="file" @change="form.custom_fee_doc = $event.target.files[0]" accept="application/pdf" />

      <div class="flex justify-end mt-6">
        <button class="text-black py-2 px-6 text-sm bg-white hover:bg-grey-lighter border border-primary rounded shadow" @click="showCustomFeeModal = false">
          <i class="fas fa-pencil-alt"></i> Close
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import ErrorBag from '@/ErrorBag'
import { EventBus } from '@/EventBus'
import AddressLookupModal from '../../components/AddressLookupModal.vue'
import { mapActions, mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import _, { debounce } from 'lodash'

export default {
  components: { AddressLookupModal, Autocomplete },
  props: {
    page: Object
  },
  data: function () {
    return {
      vendorAddressLookupOpen: false,
      addressLookupOpen: false,
      sendModalOpen: false,
      secondVendor: false,
      sameAddress: false,
      form: {
        referred_to_office_id: [],
        type_id: null,
        lead_source_id: 1,
        lead_source_url: null,
        move_reason_id: null,
        move_reason_other: null,
        financial_position_type_id: null,
        notes: null,
        vendor_title: 'Mr',
        vendor_first_name: null,
        vendor_surname: null,
        vendor_phone: null,
        vendor_email: null,
        vendor_address_name_number: null,
        vendor_address_line2: null,
        vendor_address_line3: null,
        vendor_address_town: null,
        vendor_address_line4: null,
        vendor_address_postcode: null,
        vendor_address_country: 'GB',
        vendor2_title: 'Mr',
        vendor2_first_name: null,
        vendor2_surname: null,
        vendor2_phone: null,
        vendor2_email: null,
        address_name_number: null,
        address_line2: null,
        address_thoroughfare: null,
        address_line3: null,
        address_town: null,
        address_line4: null,
        address_postcode: null,
        address_country: 'GB',
        desired_area: null,
        property_type_id: 0,
        bedrooms: 0,
        budget: 0,
        currently_listed: false,
        terms: false,
        unconfirmed_referral_fee: null,
        waiting_to_side_decision: true,
        custom_fee_doc: null
      },
      terms: {
        selling: '',
        buying: '',
        privacy: ''
      },
      loading: true,
      saving: false,
      errorBag: new ErrorBag(),
      leadSource: null,
      nearestOffice: null,
      showCustomFeeModal: false,
      agentResults: {
        data: null,
        coordinates: {
          lat: 51.5287718,
          lon: -0.2416813
        } },
      offices: [],
      map: {
        zoom: 10,
        options: {},
        showByIndex: null
      },
      showMaxErrMsg: false
    }
  },
  computed: {
    ...mapState(['referralTerms', 'selectedOffice']),
    applicantType () {
      return this.form.type_id === 1 ? 'Vendor' : 'Applicant'
    },
    vendorAddress () {
      const address = [
        this.form.vendor_address_name_number,
        this.form.vendor_address_line2,
        this.form.vendor_address_line3,
        this.form.vendor_address_town,
        this.form.vendor_address_line4,
        this.form.vendor_address_postcode].filter(Boolean).join(', ')

      if (!address) {
        return '[Not Set]'
      }

      return `${address}, ${this.form.vendor_address_country}`
    },
    address () {
      const address = [
        this.form.address_name_number,
        this.form.address_line2,
        this.form.address_line3,
        this.form.address_town,
        this.form.address_line4,
        this.form.address_thoroughfare,
        this.form.address_postcode].filter(Boolean).join(', ')

      if (!address) {
        return '[Not Set]'
      }

      return `${address}, ${this.form.address_country}`
    },
    feeType () {
      if (!this.leadSource || this.leadSource.fees.length === 0) {
        return null
      }
      return this.leadSource.fees[0][this.form.type_id === 1 ? 'vendor_fee_type_id' : 'applicant_fee_type_id']
    },
    standardFee () {
      if (!this.leadSource || this.leadSource.fees.length === 0) {
        return null
      }
      return this.leadSource.fees[0][this.form.type_id === 1 ? 'vendor_referral_fee' : 'applicant_referral_fee']
    },
    canCustomiseFee () {
      return this.feeType === 2 && this.form.type_id === 1 && !this.internationalBuyerCustomiseFee
    },
    internationalBuyerCustomiseFee () {
      return this.form.address_country !== 'GB'
    },
    currencySymbol () {
      switch (this.form.address_country) {
        case 'GB':
        case 'JE':
          return '£'
        case 'AU': return 'A$'
        case 'FR':
        case 'DE':
        case 'HU':
        case 'PT':
        case 'ES':
          return '€'
        case 'MU':
          return 'MUR'
        case 'NA':
          return 'NAD'
        case 'ZA':
          return 'ZAR'
        case 'CH':
          return 'CHF'
        case 'TH':
          return 'THB'
        case 'ZW':
          return '$'
      }
      return null
    },
    authHeaders () {
      return {
        'Authorization': 'Bearer ' + (localStorage.getItem('access') || localStorage.getItem('accessToken'))
      }
    }
  },
  created () {
    this.form.address_country = this.selectedOffice.country
    this.form.vendor_address_country = this.selectedOffice.country
    this.loadReferralTerms()
    this.form.lead_source_id = this.selectedOffice.lead_source_id || 1
    this.getLeadSource()
    this.getReferringOfficeList()
  },
  methods: {
    ...mapActions(['displayToastNotification', 'fetchReferralTerms']),
    save: function () {
      if (this.saving) {
        return
      }

      let formData = new FormData()
      for (var key in this.form) {
        if (this.form[key] === null || ((this.feeType !== 2 || this.form.referral_fee_override === this.standardFee) && ['referral_fee_override', 'custom_fee_doc'].includes(key))) {
          continue
        }
        let value = this.form[key]
        if (value === true) {
          value = 1
        } else if (value === false) {
          value = 0
        }
        if (Array.isArray(value)) {
          for (var i = 0; i < value.length; i++) {
            formData.append(key + '[]', value[i])
          }
        } else {
          formData.append(key, value)
        }
      }
      this.saving = true
      this.errorBag.clear()
      v2Api.post('/referrals', formData).then(
        (response) => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check-circle',
            title: 'Thank You',
            info: 'The referral has been created.'
          })
          EventBus.$emit('page:change-tab', 'sent')
        },
        (errors) => {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Error',
            info: errors.response.data.message
          })
          this.errorBag.store(errors.response.data)
          this.saving = false
          this.sendModalOpen = false
        }
      )
    },
    cancel: function () {
      this.$router.push('/referrals')
    },
    loadReferralTerms () {
      if (!this.referralTerms) {
        this.fetchReferralTerms().then(() => {
          this.terms = this.referralTerms
          this.loading = false
        })
      } else {
        this.terms = this.referralTerms
        this.loading = false
      }
    },
    matchAddress (prefix = 'vendor_address_', sourcePrefix = 'address_') {
      this.form[prefix + 'name_number'] = this.form[sourcePrefix + 'name_number']
      this.form[prefix + 'line2'] = this.form[sourcePrefix + 'line2']
      this.form[prefix + 'line3'] = this.form[sourcePrefix + 'line3']
      this.form[prefix + 'town'] = this.form[sourcePrefix + 'town']
      this.form[prefix + 'line4'] = this.form[sourcePrefix + 'line4']
      this.form[prefix + 'postcode'] = this.form[sourcePrefix + 'postcode']
      this.form[prefix + 'country'] = this.form[sourcePrefix + 'country']
    },
    resetAddress (prefix = 'vendor_address_') {
      this.form[prefix + 'name_number'] = null
      this.form[prefix + 'line2'] = null
      this.form[prefix + 'line3'] = null
      this.form[prefix + 'town'] = null
      this.form[prefix + 'line4'] = null
      this.form[prefix + 'postcode'] = null
      this.form[prefix + 'country'] = this.selectedOffice.country
    },
    numbersOnly (e) {
      if (e.key.length === 1 && e.key !== '.' && /\D/.test(e.key)) {
        e.preventDefault()
      }
    },
    getLeadSource () {
      let internationalFee = this.internationalBuyerCustomiseFee
      v2Api.get(`lead-sources/${this.form.lead_source_id}`, {
        params: {
          network_id: internationalFee ? 8 : this.selectedOffice.network_id
        }
      }).then((response) => {
        this.leadSource = response.data
        if (this.feeType === 0) {
          if (this.standardFee && this.internationalBuyerCustomiseFee) {
            this.form.unconfirmed_referral_fee = this.standardFee
          }
        }
      })
    },
    getReferringOfficeList () {
      this.form.referred_by_office_id = this.selectedOffice.id

      if (!this.selectedOffice.lead_source_id) {
        return
      }

      v2Api.get('office', {
        params: {
          referral_network_id: this.selectedOffice.network_id,
          all: 1
        }
      }).then((response) => {
        // Set current office as first item
        this.offices = [this.selectedOffice].concat(response.data.filter((office) => office.id !== this.selectedOffice.id))
      })
    },
    getNearestOffice: debounce(function () {
      if (!this.canCustomiseFee || !this.form.address_postcode) {
        this.nearestOffice = null
        this.form.referred_to_office_id = null
        this.form.referral_fee_override = null
        return
      }

      v2Api.get('referral-systems/office-lookup', {
        params: {
          network_id: this.selectedOffice.network_id,
          exclude_office_id: this.selectedOffice.id,
          location: this.form.address_postcode,
          country: this.form.address_country
        }
      }).then((response) => {
        this.nearestOffice = response.data
        this.form.referred_to_office_id = this.nearestOffice.id
        this.form.referral_fee_override = this.leadSource.fees[0][this.form.type_id === 1 ? 'vendor_referral_fee' : 'applicant_referral_fee']
      })
    }, 1000),
    addressEndpoint (input) {
      // return process.env.VUE_APP_ROOT_API + '/v2/address-lookup?q=' + input
      return []
    },
    addressSelected (address) {
      // get nearby offices
      this.getNearbyAgents(address.value, 2)
    },
    getNearbyAgents (keyword, maxMile) {
      let networkId = (this.selectedOffice.network_id !== 7 || this.form.address_country === 'GB') ? this.selectedOffice.network_id : 8
      v2Api.get('office', {
        params: {
          referral_network_id: networkId,
          q: keyword,
          country: this.form['address_country'],
          order_by: 'distance',
          max_mile: maxMile,
          limit_by_country: 1
        }
      }).then((response) => {
        this.map.zoom = 10
        this.agentResults = response.data
        if (!this.agentResults || this.agentResults.data.length === 0) {
          // If no location match is made then the system displays all offices in that country along with the pins on a map.
          v2Api.get('office', {
            params: {
              referral_network_id: networkId,
              q: keyword,
              country: this.form['address_country'],
              order_by: 'distance',
              limit_by_country: 1
            }
          }).then((response) => {
            this.agentResults = response.data
            this.map.zoom = 5
          })
        }
      })
    },
    updateSelectedAgent (officeId) {
      this.showMaxErrMsg = false
      if (officeId !== 0) {
        if (this.form.referred_to_office_id.includes(officeId)) {
          this.form.referred_to_office_id = _.without(this.form.referred_to_office_id, officeId)
        } else {
          this.form.referred_to_office_id.push(officeId)
        }
      }
      if (this.form.referred_to_office_id.length > 5) {
        this.showMaxErrMsg = true
        this.form.referred_to_office_id = _.without(this.form.referred_to_office_id, officeId)
      }
    }
  },
  watch: {
    selectedOffice () {
      this.form.referred_by_office_id = this.selectedOffice.id
      this.form.lead_source_id = this.selectedOffice.lead_source_id || 1
      this.form.lead_source_url = null
    },
    sameAddress: {
      handler: function (newValue) {
        this.resetAddress()
        if (newValue === true) {
          this.matchAddress()
        }
      }
    },
    address: {
      handler: function () {
        if (this.sameAddress === true) {
          this.matchAddress()
        }
      },
      deep: true
    },
    'form.type_id': {
      handler: function (value) {
        this.sameAddress = false
        if (value === 2) {
          this.resetAddress('address_')
        }
      }
    },
    'form.address_country': {
      handler () {
        if (this.form.type_id === 1) {
          this.getNearestOffice()
        } else {
          this.agentResults = {
            data: null,
            coordinates: {
              lat: 51.5287718,
              lon: -0.2416813
            } }
        }
      }
    },
    'form.address_postcode': {
      handler () {
        if (this.form.type_id === 1) {
          this.getNearestOffice()
        }
      }
    },
    'internationalBuyerCustomiseFee': {
      handler () {
        this.form.unconfirmed_referral_fee = null
        this.getLeadSource()
      }
    }
  }
}
</script>
